module.exports = __webpack_public_path__ + "static/danah_bg-cf11c4381ec01bece28ff7e18db265e6.jpeg";